import { Button } from "@alpacahq/ui";

import { BackgroundLines } from "~/v2/components/BackgroundLines";

interface IneligibleScreenProps {
  onExit: () => void;
}

export const IneligibleScreen = ({ onExit }: IneligibleScreenProps) => (
  <div className="relative flex min-h-screen w-full items-center justify-center">
    <BackgroundLines />
    <div className="flex w-full max-w-md flex-col items-center justify-center gap-10">
      <div className="flex flex-col items-center justify-center gap-4 text-gray-800">
        <h1 className="m-0 p-0 text-center font-semibold text-lg">
          Your account is not eligible to open an IRA account
        </h1>
        <p className="m-0 w-full max-w-sm p-0 text-center text-sm">
          IRA accounts are available to Trading API individual account holders
          with a valid US Social Security Number (SSN) or Individual Tax
          Identification Number (ITIN).
        </p>
      </div>
      <Button label="Got It" onClick={onExit} color="yellow" variant="filled" />
    </div>
  </div>
);
